import { observer } from "mobx-react";
import * as React from "react";
import { generalStore } from "../../../stores/GeneralStore";
import { CookieBanner } from "../../ui/CookieBanner";
import { CookieDialog } from "../../ui/CookiesDialog";
import { HrNavBar } from "../HrNavBar";
import { HrRouter } from "../router/HrRouter";
import { requestNotificationPermission } from "../../util/notifications";
import platform from "platform";

export const HrContainerSite = observer(() => {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    React.useEffect(() => {
        // Ask for desktop notification permission (except for Firefox and Safari where this is only allowed on click)
        if (platform.name !== "Firefox" && platform.name !== "Safari") {
            requestNotificationPermission();
        }
    }, []);

    return (
        <>
            {!generalStore.hideNavigation && <HrNavBar />}
            <HrRouter />
            {generalStore.acceptedCookies === false && <CookieBanner handleOpen={handleOpen} />}
            <CookieDialog isOpen={open} onBack={handleClose} onSubmit={handleSubmit} />
        </>
    );
});
